/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export interface OpenDataLicenseEntry {
    dataSource: string;
    datasetUrl: string;
    licenseTitle: string;
    licenseUrl: string;
    note: string;
    title: string;
}

export const OPEN_DATA_LICENSE_ENTRIES: OpenDataLicenseEntry[] = [
    {
        dataSource: 'City of Münster',
        datasetUrl: 'https://open.nrw/dataset/endenergieverbrauch-in-der-stadt-munster-ms',
        licenseTitle: 'Data Licence Germany – Attribution – Version 2.0 (dl-de/by-2-0)',
        licenseUrl: 'https://www.govdata.de/dl-de/by-2-0',
        note: 'The data is processed within EnObserve and prepared for visualization and analysis.',
        title: 'Final energy consumption in the City of Münster',
    },
];
